import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Doc, DocItem } from 'src/@types/docs';
import { DocsRequests } from 'src/requests/docs';
import { QueryKey } from 'src/utils/react-query';

export const useDocCoverDeleteMutation = () => {
  const queryClient = useQueryClient();

  const { mutateAsync: deleteDocCover, isLoading: isRemovingDocCoverLoading } =
    useMutation((_id: string) => DocsRequests.deleteDocCover(_id), {
      onSuccess(updatedDoc) {
        queryClient.setQueryData<DocItem[]>([QueryKey.DOCS], (contents) =>
          contents?.map((content) =>
            content._id === updatedDoc._id
              ? {
                  _id: updatedDoc._id,
                  title: updatedDoc.title,
                  order: updatedDoc.order,
                  parent: updatedDoc.parent?.[0]?._id,
                  createdAt: updatedDoc.createdAt,
                  updatedAt: updatedDoc.updatedAt,
                }
              : content,
          ),
        );

        queryClient.setQueryData<Doc>(
          [QueryKey.DOC, updatedDoc._id],
          updatedDoc,
        );
      },
    });

  return {
    isRemovingDocCoverLoading,
    deleteDocCover,
  };
};
